<template>
  <div>
    <div class="title-wrap">
      <span class="title">服务超市</span>
    </div>
    <ul class="service-wrap">
      <li class="service-item content-wrap">
        <a href="#/service-market">
          <img src="@/assets/images/service-icon-1.png" alt="" />
          <div class="service-content">
            <img src="@/assets/images/service-1.png" alt="" />
            <div class="title-wrap">
              <span class="title">政务服务</span>
              <!-- <span class="title-en">Government Service</span> -->
            </div>
          </div>
        </a>
      </li>
      <li class="service-item content-wrap">
        <a href="#/service-market">
          <img src="@/assets/images/service-icon-6.png" alt="" />
          <div class="service-content">
            <img src="@/assets/images/service-6.png" alt="" />
            <div class="title-wrap">
              <span class="title">生活服务</span>
              <!-- <span class="title-en">Life Services</span> -->
            </div>
          </div>
        </a>
      </li>
      <li class="service-item content-wrap">
        <a href="#/service-market">
          <img src="@/assets/images/service-icon-5.png" alt="" />
          <div class="service-content">
            <img src="@/assets/images/service-5.png" alt="" />
            <div class="title-wrap">
              <span class="title">安居服务</span>
              <!-- <span class="title-en">Secure Housing Services</span> -->
            </div>
          </div>
        </a>
      </li>
      <li class="service-item content-wrap">
        <a href="#/service-market">
          <img src="@/assets/images/service-icon-2.png" alt="" />
          <div class="service-content">
            <img src="@/assets/images/service-2.png" alt="" />
            <div class="title-wrap">
              <span class="title">科创服务</span>
              <!-- <span class="title-en">Science and Technology Innovation Services</span> -->
            </div>
          </div>
        </a>
      </li>
      <li class="service-item content-wrap">
        <a href="#/service-market">
          <img src="@/assets/images/service-icon-4.png" alt="" />
          <div class="service-content">
            <img src="@/assets/images/service-4.png" alt="" />
            <div class="title-wrap">
              <span class="title">助企服务</span>
              <!-- <span class="title-en">Enterprise Assistance Services</span> -->
            </div>
          </div>
        </a>
      </li>
      <li class="service-item content-wrap">
        <a href="#/service-market">
          <img src="@/assets/images/service-icon-3.png" alt="" />
          <div class="service-content">
            <img src="@/assets/images/service-3.png" alt="" />
            <div class="title-wrap">
              <span class="title">金融服务</span>
              <!-- <span class="title-en">Financial Service</span> -->
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ServiceMarket',
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
